import React from 'react';
import './Service.css';
import { TbTruckDelivery } from "react-icons/tb";
import { RiSecurePaymentLine } from "react-icons/ri";
import { FaShieldAlt } from "react-icons/fa";
import { BiSupport } from "react-icons/bi";

const Service = () => {
    const data = [
        {
            cover: <TbTruckDelivery/>,
            title: "Worldwide Delivery",
            decs: "We offer competitive prices on our 100 million plus product any range.",
        },
        {
            cover: <RiSecurePaymentLine/>,
            title: "Safe Payment",
            decs: "We offer competitive prices on our 100 million plus product any range.",
        },
        {
            cover: <FaShieldAlt/>,
            title: "Shop With Confidence ",
            decs: "We offer competitive prices on our 100 million plus product any range.",
        },
        {
            cover: <BiSupport/>,
            title: "24/7 Support ",
            decs: "We offer competitive prices on our 100 million plus product any range.",
        },
    ]
    return (
        <>
            <section className='wrapper background'>
                <div className='container grid2'>
                    {data.map((val, index) => {
                        return (
                            <div className='product' key={index}>
                                <div className='img icon-circle'>
                                    <i>{val.cover}</i>
                                </div>
                                <h3>{val.title}</h3>
                                <p>{val.decs}</p>
                            </div>
                        )
                    })}
                </div>
            </section>
        </>
    );
};

export default Service;